import api from './api';

/**
 * Liquidación del asesor cd-2b con la empresa matriz (docs/cd2b-matriz-pagos-y-equipo.md §6.3):
 * sus datos fiscales con códigos del MH, el documento de cada pago y la carga de su CCF.
 * Guardar los datos fiscales exige el código 2FA (`X-2FA-Token`).
 */
const cd2bLiquidacionService = {
  async datosFiscales() {
    const r = await api.get('/partners/liquidacion/datos-fiscales');
    return r.data;
  },

  async guardarDatosFiscales(datos, codigo2fa = '') {
    const headers = codigo2fa ? { 'X-2FA-Token': String(codigo2fa).trim() } : undefined;
    const r = await api.put('/partners/liquidacion/datos-fiscales', datos, headers ? { headers } : undefined);
    return r.data;
  },

  async pagos() {
    const r = await api.get('/partners/liquidacion/pagos');
    return r.data;
  },

  /** `dteJson`: el JSON del CCF tal como lo devolvió el MH (con su sello). */
  async subirCcf(payoutId, dteJson, selloRecepcion = '') {
    const r = await api.post(`/partners/liquidacion/pagos/${payoutId}/ccf`, { dteJson, selloRecepcion: selloRecepcion || undefined });
    return r.data;
  },
};

export default cd2bLiquidacionService;
